(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-v2"]) return;
  try {
    
  /* Mirrors StickyHeader from header.liquid: pin the bar, swap between the
     translucent "at top" state and the solid state once the hero is half
     scrolled past. `.homepage-header` is the v2 hero and is included in the
     hero selector alongside the v1 sections. */
  const HB_HERO_SELECTOR =
    '.homepage-header, .homepage-hero, .compare, .section-compare, .collection-hero, .image-banner--at-top'

  class StickyHeaderV2 extends HTMLElement {
    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header')
      this.headerWrapper = this
      this.scrollTicking = false

      this.refreshHero()

      this.onScrollHandler = this.onScroll.bind(this)
      window.addEventListener('scroll', this.onScrollHandler, { passive: true })

      this.onSectionReload = this.refreshHero.bind(this)
      document.addEventListener('shopify:section:load', this.onSectionReload)
      document.addEventListener('shopify:section:unload', this.onSectionReload)

      /* Positioning and height reservation are pure CSS (see
         section-header-v2.css): the v1 header pins itself and injects a spacer
         from JS, which lands ~7s into a slow-4G load and shifts the whole page
         down by the header height. The v2 bar is a fixed 72px, so the section
         reserves that in flow and the wrapper is fixed - no JS, no shift. */
      if (this.header) {
        this.resizeObserver = new ResizeObserver(() => {
          if (this.heroEl) this.cachedThreshold = this.heroEl.offsetHeight * 0.5
        })
        this.resizeObserver.observe(this.header)
      }

      // Pages without a hero never get the translucent state.
      if (!this.heroEl) {
        this.classList.remove('header--at-top')
      }
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler)
      document.removeEventListener('shopify:section:load', this.onSectionReload)
      document.removeEventListener('shopify:section:unload', this.onSectionReload)
      if (this.resizeObserver) this.resizeObserver.disconnect()
    }

    /* Re-query on section load/unload: the theme editor swaps sections via the
       Section Rendering API, which leaves a stale detached node behind
       (offsetHeight === 0) and silently zeroes the threshold. */
    refreshHero() {
      this.heroEl = document.querySelector(HB_HERO_SELECTOR)
      this.cachedThreshold = this.heroEl ? this.heroEl.offsetHeight * 0.5 : 0
    }

    onScroll() {
      if (this.scrollTicking) return
      this.scrollTicking = true

      requestAnimationFrame(() => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop

        if (this.heroEl && scrollTop < this.cachedThreshold) {
          this.classList.add('header--at-top')
        } else {
          this.classList.remove('header--at-top')
        }

        this.scrollTicking = false
      })
    }
  }

  if (!customElements.get('sticky-header-v2')) {
    customElements.define('sticky-header-v2', StickyHeaderV2)
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
		constructor() {
			super()
		}

		connectedCallback() {
			this.header = document.querySelector('.shopify-section-header')
			this.headerWrapper = document.querySelector('.header-wrapper')
			this.currentScrollTop = 0
			this.scrollTicking = false

			// Cache hero element and threshold (don't re-query on every scroll)
			// Pages WITH a hero (home: .homepage-hero, trade: .compare) get
			// transparent-at-top + opaque-on-scroll. Pages without a hero stay opaque.
			// Hero sections trigger the transparent-at-top header state.
			// `image-banner--at-top` is added by image-banner.liquid when
			// section.index == 1, so any image-banner placed first on a
			// page is treated as a hero (e.g. consumer-how-it-works).
			this.heroEl = document.querySelector('.homepage-hero, .compare, .section-compare, .collection-hero, .image-banner--at-top')
			this.cachedThreshold = this.heroEl ? this.heroEl.offsetHeight * 0.5 : 0

			this.onScrollHandler = this.onScroll.bind(this)
			window.addEventListener('scroll', this.onScrollHandler, { passive: true })

			/* Theme-editor: when a section reloads via the Section Rendering
			   API, the cached `this.heroEl` becomes a stale pointer to a
			   detached node (offsetHeight === 0) which silently corrupts the
			   threshold. Re-query on every section load + unload so the
			   hero reference stays fresh while the user edits. */
			this.onSectionReload = function () {
				this.heroEl = document.querySelector(
					'.homepage-hero, .compare, .section-compare, .collection-hero, .image-banner--at-top'
				)
				if (this.heroEl) {
					this.cachedThreshold = this.heroEl.offsetHeight * 0.5
				} else {
					this.cachedThreshold = 0
				}
			}.bind(this)
			document.addEventListener('shopify:section:load', this.onSectionReload)
			document.addEventListener('shopify:section:unload', this.onSectionReload)

			/* On hero pages, hovering the header forces the opaque colour scheme
			   so the navbar + open mega menu stay legible. While hovered the
			   scroll handler must NOT yank opaque back off, otherwise scrolling
			   with the menu open would flash transparent. */
			this.isHeaderHovered = false
			this.onHeaderEnter = function () {
				this.isHeaderHovered = true
				if (this.header) {
					this.header.classList.add('header--opaque')
				}
			}.bind(this)
			this.onHeaderLeave = function () {
				this.isHeaderHovered = false
				if (this.headerWrapper && this.headerWrapper.classList.contains('header--at-top') && this.header) {
					this.header.classList.remove('header--opaque')
				}
			}.bind(this)
			if (this.headerWrapper) {
				this.headerWrapper.addEventListener('mouseenter', this.onHeaderEnter)
				this.headerWrapper.addEventListener('mouseleave', this.onHeaderLeave)
			}

			// Pin header to viewport top permanently
			if (this.header) {
				this.header.style.position = 'fixed'
				this.header.style.top = '0'
				this.header.style.left = '0'
				this.header.style.right = '0'
				this.header.style.zIndex = '12'

				// Spacer keeps content from jumping behind fixed header
				this.headerSpacer = document.createElement('div')
				this.headerSpacer.style.height = this.header.offsetHeight + 'px'
				this.headerSpacer.style.overflow = 'hidden'
				this.headerSpacer.setAttribute('aria-hidden', 'true')
				this.header.after(this.headerSpacer)

				// Keep spacer in sync with header height changes
				this.resizeObserver = new ResizeObserver(() => {
					this.headerSpacer.style.height = this.header.offsetHeight + 'px'
					// Recalculate threshold on resize (hero height may change)
					if (this.heroEl) {
						this.cachedThreshold = this.heroEl.offsetHeight * 0.5
					}
				})
				this.resizeObserver.observe(this.header)
			}

			// Initial state:
			// - Pages WITH a hero: start translucent (header--at-top is on wrapper from Liquid).
			// - Pages WITHOUT a hero (product, cart, collection, etc.): stay opaque always.
			if (this.header && this.headerWrapper) {
				if (!this.heroEl) {
					this.headerWrapper.classList.remove('header--at-top')
					this.header.classList.add('header--opaque')
				} else {
					this.header.classList.remove('header--opaque')
				}
			}
		}

		disconnectedCallback() {
			window.removeEventListener('scroll', this.onScrollHandler)
			if (this.headerWrapper && this.onHeaderEnter) {
				this.headerWrapper.removeEventListener('mouseenter', this.onHeaderEnter)
				this.headerWrapper.removeEventListener('mouseleave', this.onHeaderLeave)
			}
			if (this.resizeObserver) this.resizeObserver.disconnect()
			if (this.headerSpacer) {
				this.headerSpacer.remove()
				this.headerSpacer = null
			}
		}

		onScroll() {
			if (this.scrollTicking) return
			this.scrollTicking = true
			requestAnimationFrame(() => {
				const scrollTop = window.pageYOffset || document.documentElement.scrollTop

				if (this.headerWrapper && this.header) {
					if (this.heroEl) {
						// Hero pages: transparent at top, opaque on scroll.
						// While the user is hovering the header (menu likely open)
						// keep opaque locked on regardless of scroll position so
						// the menu surface never flashes transparent mid-scroll.
						if (scrollTop < this.cachedThreshold) {
							this.headerWrapper.classList.add('header--at-top')
							if (!this.isHeaderHovered) {
								this.header.classList.remove('header--opaque')
							}
						} else {
							this.headerWrapper.classList.remove('header--at-top')
							this.header.classList.add('header--opaque')
						}
					} else {
						// Non-hero pages: always opaque
						this.headerWrapper.classList.remove('header--at-top')
						this.header.classList.add('header--opaque')
					}
				}

				/* Header stays pinned at the top of the viewport at every scroll
				   position — on mobile and desktop. The previous "hide on scroll
				   down, show at footer" logic was hiding the hamburger reliably
				   when the user reached the footer, which broke navigation
				   accessibility from the bottom of long pages.
				   On mobile we also unconditionally strip
				   `shopify-section-header-hidden` (added by sections like
				   scrolling-rental-price-hero via GSAP scrub-driven animations)
				   so the hamburger remains visible at every scroll position. */
				if (this.header) {
					this.header.classList.remove('header--hidden')
					if (window.innerWidth < 990) {
						this.header.classList.remove('shopify-section-header-hidden')
						// Also remove the body class that GSAP-driven sections add,
						// which triggers the CSS transform that hides the header.
						// Desktop retains the hide behaviour; mobile never hides.
						document.body.classList.remove('srph-hide-header')
					}
				}

				this.currentScrollTop = scrollTop
				this.scrollTicking = false
			})
		}

		closeMenuDisclosure() {
			this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure')
			if (this.disclosures) {
				this.disclosures.forEach((disclosure) => {
					disclosure.close()
				})
			}
			this.disclosureLists = this.header.querySelectorAll('.disclosure__list')
			if (this.disclosureLists) {
				this.disclosureLists.forEach((disclosureList) => {
					disclosureList.setAttribute('hidden', true)
				})
			}
		}
	}

	customElements.define('sticky-header', StickyHeader)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
class ProductModal extends ModalDialog {
	constructor() {
		super();
	}

	hide() {
		super.hide();
		window.pauseAllMedia();
	}

	show(opener) {
		super.show(opener);
		this.showActiveMedia();
	}

	showActiveMedia() {
		const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);

		if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
			activeMedia.loadContent();
	}
}

customElements.define('product-modal', ProductModal);


  } catch(e) { console.error(e); }
})();
})();
